import React, { useContext, useEffect, useState } from 'react';

import {
    Grid,
    Paper,
    Chip,
    Link,
    Button,
    Table,
    TablePagination,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Typography,
    Tooltip,
    IconButton,
    colors
} from '@material-ui/core';

import {
    DateTime
} from '../../../common';

import { PageContext } from '../PageContext';
import { PluginContext } from '../../../contexts';

import { ProcessStatus, getColoredBottonStyle } from '../../../../helpers';

import { useTranslation } from "react-i18next";

import AppleIcon from '@material-ui/icons/Apple';
import AndroidIcon from '@material-ui/icons/Android';
import HelpIcon from '@material-ui/icons/Help';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import ErrorIcon from '@material-ui/icons/Error';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import DoneIcon from '@material-ui/icons/Done';
import GetAppIcon from '@material-ui/icons/GetApp';
import HourglassFullIcon from '@material-ui/icons/HourglassFull';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import SyncIcon from '@material-ui/icons/Sync';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import AccessTimeOutlinedIcon from '@material-ui/icons/AccessTimeOutlined';

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
        overflow: "hidden"
    },
    tableHead: {
        backgroundColor: theme.palette.primary.main,
        color: "#fff",
    },
    tableCellHeader: {
        backgroundColor: theme.palette.primary.main,
        color: "#fff",
    },
    tableContainer: {
        marginTop: 16,
        marginBottom: 16,
    },
    tableLoader: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: theme.spacing(4),
    },
    overlayContainer: {
        position: "relative"
    },
    overlay: {
        position: "absolute",
        top: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        opacity: ".4"
    },
    deleteButton: {
        ...getColoredBottonStyle(theme, colors.red)
    }
}));

export const BuildsList = ({
    itemsPerPage,
    loading,
    disabled,
    onLoadMore,
    onAction,
    ...props }) => {
    const classes = useStyles();

    const { t } = useTranslation();

    const {
        getAssetUrl
    } = useContext(PluginContext);

    const {
        state,
        isBusy,
    } = useContext(PageContext);

    const {
        builds,
    } = state;

    const [pageIndex, setPageIndex] = useState(-1);
    const pageIndexChangeHandler = (e, index) => {
        setPageIndex(index);
    }

    const [pageSize, setPageSize] = useState(itemsPerPage);
    const pageSizeChangeHandler = (e) => {
        setPageSize(e.target.value)
        if (pageIndex < 0)
            setPageIndex(0);
    }


    const getDeviceBuildTypeIcon = (buildDeviceType) => {
        switch (buildDeviceType) {
            case "Android":
                return (
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <AndroidIcon />
                        <Typography variant="body2" style={{ paddingLeft: 10 }}>
                            {buildDeviceType}
                        </Typography>
                    </div>
                );
            case "iOS":
                return (
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <AppleIcon />
                        <Typography variant="body2" style={{ paddingLeft: 10 }}>
                            {buildDeviceType}
                        </Typography>
                    </div>
                );
            default:
                return (
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <HelpOutlineIcon />
                        <Typography variant="body2" style={{ paddingLeft: 10 }}>
                            {buildDeviceType}
                        </Typography>
                    </div>
                );
        }
    }

    const getBuildDeviceTypes = (build) => {
        if (build.deviceBuilds) {
            const deviceTypes = [];
            build.deviceBuilds.forEach(x => {
                deviceTypes.push(
                   <div key={'dummy'} style={{ margin: 8 }}>
                        {getDeviceBuildTypeIcon(x.deviceType)}
                    </div>
                );
            });
            return deviceTypes;
        } else {
            switch (build.status) {
                case ProcessStatus.Enqueued:
                    return (
                        <div style={{ margin: 8 }}>
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <AccessTimeIcon />
                                <Typography variant="body2" style={{ paddingLeft: 10 }}>
                                    {t("LabelBuildNotStarted")}
                                </Typography>
                            </div>
                        </div>
                    );
                case ProcessStatus.Processing:
                    return (
                        <div style={{ margin: 8 }}>
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <SyncIcon />
                                <Typography variant="body2" style={{ paddingLeft: 10 }}>
                                    {t("LabelBuildInProgress")}
                                </Typography>
                            </div>
                        </div>
                    );
                case ProcessStatus.Canceled:
                    return (
                        <div style={{ margin: 8 }}>
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <RemoveCircleIcon />
                                <Typography variant="body2" style={{ paddingLeft: 10 }}>
                                    {t("LabelBuildCanceled")}
                                </Typography>
                            </div>
                        </div>
                    );
                case ProcessStatus.Faulty:
                    return (
                        <div style={{ margin: 8 }}>
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <ErrorIcon />
                                <Typography variant="body2" style={{ paddingLeft: 10 }}>
                                    {t("LabelBuildFailed")}
                                </Typography>
                            </div>
                        </div>
                    );
            }

        }
    }

    const getDeviceBuildStatusIcon = (buildStatus, buildResult) => {
        switch (buildStatus) {
            case "notStarted":
                return (
                    <div>
                        <Chip
                            color="primary"
                            label={t("LabelBuildNotStarted")}
                            icon={<HourglassFullIcon />}
                        />
                    </div>
                );
            case "inProgress":
                return (
                    <div>
                        <Chip
                            color="primary"
                            label={t("LabelBuildInProgress")}
                            icon={<SyncIcon />}
                        />
                    </div>
                );
            case "cancelling":
                return (
                    <div>
                        <Chip
                            color="primary"
                            label={t("LabelBuildCancelling")}
                            icon={<RemoveCircleIcon />}
                        />
                    </div>
                );

            case "completed":
                if (buildResult === "failed") {
                    return (
                        <div>
                            <Chip
                                color="primary"
                                label={t("LabelBuildFailed")}
                                icon={<ErrorOutlineIcon color="error" />}
                            />
                        </div>
                    );
                } else if (buildResult === "canceled") {
                    return (
                        <div>
                            <Chip
                                color="primary"
                                label={t("LabelBuildCanceled")}
                                icon={<RemoveCircleIcon />}
                            />
                        </div>
                    );
                } else if (buildResult === "succeeded") {
                    return (
                        <div>
                            <Chip
                                color="primary"
                                label={t("LabelBuildCompleted")}
                                icon={<DoneIcon />}
                            />
                        </div>
                    );
                } else {
                    return (
                        <div>
                            <Chip
                                color="primary"
                                label={t("LabelBuildUnknown")}
                                icon={<HelpIcon />}
                            />
                        </div>
                    );
                }
            default:
                return (
                    <div>
                        <Chip
                            color="primary"
                            label={t("LabelBuildUnknown")}
                            icon={<HelpIcon />}
                        />
                    </div>
                );
        }
    }

    const getBuildStatusIcons = (build) => {
        if (build.deviceBuilds) {
            const statusIcons = [];
            build.deviceBuilds.forEach(x => {
                statusIcons.push(
                   <div key={'dummy'} style={{ margin: 8 }}>
                        {getDeviceBuildStatusIcon(x.buildStatus, x.buildResult)}
                    </div>
                );
            });
            return statusIcons;
        } else {
            switch (build.status) {
                case ProcessStatus.Enqueued:
                    return (
                        <div style={{ margin: 8 }}>
                            <Chip
                                color="primary"
                                label={t("LabelBuildNotStarted")}
                                icon={<HourglassFullIcon />}
                            />
                        </div>
                    );
                case ProcessStatus.Processing:
                    return (
                        <div style={{ margin: 8 }}>
                            <Chip
                                color="primary"
                                label={t("LabelBuildInProgress")}
                                icon={<SyncIcon />}
                            />
                        </div>
                    );
                case ProcessStatus.Canceled:
                    return (
                        <div style={{ margin: 8 }}>
                            <Chip
                                color="primary"
                                label={t("LabelBuildCanceled")}
                                icon={<RemoveCircleIcon color="error" />}
                            />
                        </div>
                    );
                case ProcessStatus.Faulty:
                    return (
                        <div style={{ margin: 8 }}>
                            <Chip
                                color="primary"
                                label={t("LabelBuildFailed")}
                                icon={<ErrorOutlineIcon color="error" />}
                            />
                        </div>
                    );
            }
        }
    }

    const getBuildActions = (build) => {
        const actions = [];
        switch (build.status) {
            case ProcessStatus.Enqueued:
            case ProcessStatus.Processing:
                if (build.deviceBuilds) {
                    build.deviceBuilds
                        .filter(x => x.buildStatus === "completed" && x.buildResult === "succeeded")
                        .forEach(deviceBuild => {
                            if (build.deviceBuilds) {
                               build.deviceBuilds.forEach(bundle => {
                                    actions.push(
                                        <div key={bundle.name} style={{ margin: 8 }}>
                                            {getDownloadAction(build, bundle)}
                                        </div>
                                    );
                                });
                            } else {
                                actions.push(
                                   <div key={'dummy'} style={{ margin: 8 }}>
                                        {getPreDownloadAction(deviceBuild)}
                                    </div>
                                );
                            }
                        });
                }
                //actions.push(
                //    <div key="cancel" style={{ margin: 8 }}>
                //        <Tooltip title={t("LabelBuildCancel")}>
                //            <span>
                //                <Button
                //                    size="small"
                //                    color="secondary"
                //                    variant="outlined"
                //                    onClick={() => cancelClickHandler(build)}
                //                    disabled={isBusy()}>
                //                    {t("LabelBuildCancel")}
                //                </Button>
                //            </span>
                //        </Tooltip>
                //    </div>
                //);
                return actions;
            case ProcessStatus.Completed:
                build.deviceBuilds.forEach(bundle => {
                    actions.push(
                        <div key={bundle.name} style={{ margin: 8 }}>
                            {getDownloadAction(build, bundle)}
                        </div>
                    );
                });
                //actions.push([
                //    <div key="delete" style={{ margin: 8 }}>
                //        {getDeleteAction(build)}
                //    </div>
                //]);
                return actions;
            case ProcessStatus.Canceled:
            case ProcessStatus.Faulty:
                //actions.push([
                //    <div key="delete" style={{ margin: 8 }}>
                //        {getDeleteAction(build)}
                //    </div>
                //]);
                return actions;
        }
    }

    const getPreDownloadAction = (deviceBuild) => {
        return (
            <Tooltip
                title={`${t("LabelBuildDownload")} ${deviceBuild.deviceType}`}>
                <Typography variant="caption" color="primary">
                    {t("LabelPreparingBuildDownload")}<br />
                    <Typography variant="button" color="secondary">
                        {deviceBuild.deviceType}
                    </Typography>
                </Typography>
            </Tooltip>
        );
    }

    const getDownloadAction = (build, bundle) => {
        return (
            <Tooltip
                title={`${t("LabelBuildDownload")} ${bundle.name}`}>
                <Typography variant="caption" color="primary">
                    {t("LabelBuildDownload")}<br />
                    <Link
                        href="#"
                        onClick={(e) => {
                            e.preventDefault();
                            downloadClickHandler(build, bundle)
                        }}
                        disabled={isBusy()}>
                        <Typography variant="button" color="secondary">
                            {bundle.name}
                        </Typography>
                    </Link>
                </Typography>
            </Tooltip>
        );
    }

    const getDeleteAction = (build) => {
        return (
            <Tooltip title={t("LabelBuildDelete")}>
                <span>
                    <Button
                        size="small"
                        className={classes.deleteButton}
                        color="secondary"
                        variant="outlined"
                        onClick={() => deleteClickHandler(build)}
                        disabled={isBusy()}>
                        {t("LabelBuildDelete")}
                    </Button>
                </span>
            </Tooltip>
        );
    }

    const downloadClickHandler = (build, bundle) => {
        if (onAction) {
            onAction("download", build, bundle);
        }
    }

    const cancelClickHandler = (build) => {
        if (onAction) {
            onAction("cancel", build);
        }
    }

    const deleteClickHandler = (build) => {
        if (onAction) {
            onAction("delete", build);
        }
    }

    useEffect(() => {
        if (pageIndex !== -1 && onLoadMore) {
            onLoadMore(Math.max(0, pageIndex), pageSize);
        }
    }, [pageIndex, pageSize]);

    return (
        <Paper className={classes.root}>
            <div className={classes.overlayContainer}>
                <Table className={classes.table} aria-label="simple table">
                    <TableHead className={classes.tableHead}>
                        <TableRow >
                            <TableCell
                                className={classes.tableCellHeader}
                                style={{ width: "30%" }}>
                                {t("LabelBuildName")}
                            </TableCell>
                            <TableCell
                                className={classes.tableCellHeader}
                                style={{ width: "20%" }}>
                                {t("LabelBuildDate")}
                            </TableCell>
                            <TableCell
                                className={classes.tableCellHeader}
                                style={{ width: "15%" }}>
                                {t("LabelBuildDeviceType")}
                            </TableCell>
                            <TableCell
                                className={classes.tableCellHeader}
                                style={{ width: "15%" }}>
                                {t("LabelBuildStatus")}
                            </TableCell>
                            <TableCell
                                align="center"
                                className={classes.tableCellHeader}>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {builds && builds.map((build, index) => (
                            <TableRow key={index}>
                                <TableCell component="th" scope="row">
                                    {build.buildName}
                                    <Grid container>
                                        <Grid item>
                                            <Typography variant="caption" color="secondary">
                                                {build.processMessage}
                                            </Typography>
                                        </Grid>
                                        {build.processException &&
                                            <Grid item>
                                                &nbsp;
                                                <Tooltip title={build.processException}>
                                                    <ErrorIcon fontSize="small" color="error" />
                                                </Tooltip>
                                            </Grid>
                                        }
                                    </Grid>
                                </TableCell>
                                <TableCell>
                                    {build.queueDate ?
                                        <DateTime date time value={new Date(build.queueDate)} />
                                        :
                                        "-"
                                    }
                                </TableCell>
                                <TableCell>
                                    {getBuildDeviceTypes(build)}
                                </TableCell>
                                <TableCell>
                                    {getBuildStatusIcons(build)}
                                </TableCell>
                                <TableCell>
                                    {getBuildActions(build)}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
                {loading && <div className={classes.overlay} />}
            </div>
        </Paper>
    );
}